import React from 'react'
import { useTranslation } from 'react-i18next'
import Icon from '../Icon'

interface IProps {
    errorMessages?: string[]
}

const ComponentError = (props: IProps) => {
    const { t } = useTranslation()
    const errors =
        (props.errorMessages && props.errorMessages.length === 0) ||
        !props.errorMessages
            ? [t('error.cantload')]
            : props.errorMessages
    return (
        <div className='component-error'>
            <Icon
                iconName="warning"
                size={50}
                color={`#ee7202`}
            />
            <div className='component-error__text-container' role="status">
                <span className='component-error__header'>{t('error.somethingwrong')}</span>
                {errors &&
                    errors.map((errorMessage, index) => (
                        <span className='component-error__text' key={`errorMessage_${index}`}>
                            {errorMessage}
                        </span>
                    ))}
            </div>
        </div>
    )
}

export default ComponentError